module.exports = __webpack_public_path__ + "img/wa-e.a0fdccda.png";